import { lazy } from "react";
import { useRoutes, Navigate } from "react-router-dom";
import Loadable from "ui-component/Loadable";

// routes
import MainRoutes from "./MainRoutes";
import LoginRoutes from "./LoginRoutes";
import AuthenticationRoutes from "./AuthenticationRoutes";

const GoogleOAuthCallback = Loadable(
  lazy(() =>
    import("views/pages/authentication/authentication3/GoogleOAuthCallback"),
  ),
);

// ==============================|| ROUTING RENDER ||============================== //

export default function ThemeRoutes() {
  return useRoutes([
    { path: "/", element: <Navigate to="/login" replace /> },
    { path: "/oauth/google/callback", element: <GoogleOAuthCallback /> },
    AuthenticationRoutes,
    LoginRoutes,
    MainRoutes,
    { path: "*", element: <Navigate to="/login" replace /> },
  ]);
}
